import { type ApolloError, useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { GetAudienceDocument } from '../../../../graphql/query/audiences/GetAudience.generated';
import type { AudienceForm } from '../../AudienceForm/types';
import { mapToAudienceForm } from '../../utils/mapToAudienceForm';

type UseAudienceResponse = {
  audience: AudienceForm;
  loading: boolean;
  error?: ApolloError;
};

export const useAudienceFetch = (): UseAudienceResponse => {
  const { audienceUid = '' } = useParams<{
    audienceUid: string;
  }>();
  const { data, error, loading } = useQuery(GetAudienceDocument, { variables: { id: audienceUid } });

  return {
    audience: mapToAudienceForm(data ?? null),
    error,
    loading,
  };
};
